export default {
	"name": "authorized.by",
	"stage": "produktion",
	"mandanten": ["55"],
	"pagetypes": "produkt",
	"requiresConsent": true,
	"serviceSettings": {
		"scriptSrc": "https://app.authorizedpartner.com/badge-integrator/entry/main.js"
	}
}
